export default {
  STATUS: {
    canceled_0: 0, // 已取消
    waittingToUploadMaterial_1: 1, // 待上传资料
    waittingToWriteApplicantion_2: 2, // 待填写申请表
    waittingToPay_3: 3, // 待支付
    waittingToSendMaterial_4: 4, // 待邮寄资料
    processing_5: 5, // 办理中
    deliveried_6: 6, // 已发货
    waittingToEvaluation_7: 7, // 待评价
    finished_8: 8, // 已完成
    deleted_9: 9, // 已删除
    waittingToSelectGoToEmbassyTime_10: 10, // 待选择赴馆日期
  },
  NEED_DELIVERY: {
    no: 0, // 不需要
    needAndNotAlongWith: 1, // 需要不陪签
    needAndAlongWith: 2, // 需要且陪签
  },
  NEED_INTERVIEW: {
    no: 0, // 不需要
    needAndNotAlongWith: 1, // 需要不陪签
    needAndAlongWith: 2, // 需要且陪签
  },
  DATE_CHOICE: {
    manual: 0, // 手动选择时间
    last30Day: 1, // 近30天都可以
    notLast30Day: 2, // 近30天都不行
    beforeDepart: 3,
    after30Day: 4,
  },
  VISA_FORM: {
    papery: 0, // 贴纸签
    elec: 1, // 电子签
    otherPapery: 2, // 另纸签
    approval: 3, // 批文
  },
  NEED_PICKUP: {
    yes: 1, // 顺丰上门取件
    no: 0, // 其他
  },
  OFFLINE: {
    yes_1: 1,
    no_0: 0,
  },


};



// WEBPACK FOOTER //
// ./src/constants/order-constants.js